export function formatDuration(num: number) {
  const minutes = Math.floor(num / 60)
  const seconds = num % 60

  return `${minutes}`.padStart(1, '0') + ':' + `${seconds}`.padStart(2, '0')
}

export function formatDurationISO8601(num: number) {
  const minutes = Math.floor(num / 60)
  const seconds = num % 60

  return `PT${minutes}M${seconds}S`
}
